import { persistentAtom } from "@nanostores/persistent"

export const $subjectPropertyWalkthroughDismissed = persistentAtom<
  boolean | null
>("userPrefs.subjectPropertyWalkthroughDismissed", null, {
  encode: (val) => JSON.stringify(val), // Encode as JSON for storage
  decode: (val) => (val === null ? null : JSON.parse(val)), // Decode from JSON
})

// Helper to mark the walkthrough as dismissed
export const setSubjectPropertyWalkthroughDismissed = () => {
  $subjectPropertyWalkthroughDismissed.set(true)
}

// Helper to reset the walkthrough
export const resetSubjectPropertyWalkthrough = () => {
  $subjectPropertyWalkthroughDismissed.set(null)
}
